import { Form, FormProps, Input } from 'antd';
import React from 'react';
import styled from 'styled-components';
import fozito_logo from 'assets/logo.svg';
import user_name_icon from './icons/username.svg';
import password_icon from './icons/password.svg';
import { Button, Text, Checkbox } from '@fozito/common-ui';

const PrefixIcon = styled.div`
  padding-left: 6px;
  padding-right: 12px;
  border-right: 1px solid #CCD4DC;
`;
const prefixUsernameInput = <PrefixIcon><img src={user_name_icon} alt='user_name_icon' style={{ height: 26, width: 26 }} /></PrefixIcon>;
const prefixPasswordInput = <PrefixIcon><img src={password_icon} alt='password_icon' style={{ height: 26, width: 26 }} /></PrefixIcon>;


const Container = styled(Form)`
display: flex;
width: 600px;
padding: 24px 40px;
margin-top: 100px;
flex-direction: column;
align-items: center;
gap: 0px;
border-radius: 16px;
background: #F6F7FC;
box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.10);
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-bottom: 1.5rem;
  .logo {
    display: flex;
    width: auto;
    height: 64px;
    justify-content: center;
    align-items: center;
  }

  .title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    h5 {
      color: #1D2129;
      text-align: center;
      font-family: Chivo;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;

  .group-input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;

    .input-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      align-self: stretch;
    }

    .saved-login {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      .checkbox, .checkbox-indeterminate {
        width: 32px;
        height: 32px;
      }
      .title_h7_20_semibold, .title_h6_20_regular {
        font-size: 16px;
      }

    }
  }

  .ant-input-affix-wrapper>input.ant-input, input.ant-input {
    line-height: 3;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }
`;

interface FormLoginProps extends FormProps { }
const FormLogin = (props: FormLoginProps) => {
  return (
    <Container {...props}>
      <Header>
        <img src={fozito_logo} alt="fozito_logo" className="logo" />
      </Header>
      <FormContainer>
        <div className="group-input-container">
          <div className="input-container">
            <Form.Item name={'username'} noStyle>
              <Input prefix={prefixUsernameInput} placeholder='Username or email' />
            </Form.Item>
            <Form.Item name={'password'} noStyle>
              <Input.Password prefix={prefixPasswordInput} placeholder='Password' />
            </Form.Item>
          </div>
          <div className="saved-login">
            <Form.Item noStyle name={'remember'}>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            <Text title_h7_20_semibold text_center color_secondary_3 >Forgot password?</Text>
          </div>
        </div>
        <Button type='submit' block type_primary style={{padding:'12px 16px'}}>Sign In</Button>
      </FormContainer>
    </Container>
  );
};

export default FormLogin;
